import { get } from "lodash";
import { P } from "orcs-design-system";
import type { CSSProperties, ReactNode } from "react";

type NodeShape = {
  name?: string | undefined;
  active?: boolean | undefined;
  isPlaceholder?: boolean | undefined;
  group?:
    | { isHidden?: boolean | undefined; [key: string]: unknown }
    | Record<string, unknown>
    | undefined;
  [key: string]: unknown;
};

type TreeNodeLabelProps = {
  node: NodeShape;
  children?: ReactNode;
  style?: CSSProperties;
  "data-testid"?: string;
};

/**
 * Standard label `<P>` for tree node rows. Handles isHidden (strikethrough-grey)
 * and isPlaceholder (muted) colour, ellipsis overflow, and data-tree-row-content
 * so TreeRow's active/hover colour transition applies.
 */
const TreeNodeLabel = ({
  node,
  children,
  style,
  "data-testid": testId = "treeheader-node-name",
}: TreeNodeLabelProps) => {
  const color = get(node, "group.isHidden")
    ? "subText"
    : node.isPlaceholder
      ? "subText"
      : undefined;

  return (
    <P
      fontWeight="1"
      fontSize="1"
      data-testid={testId}
      data-tree-row-content
      color={color}
      style={{
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children ?? node.name}
    </P>
  );
};

// fallow-ignore-next-line unused-export
export default TreeNodeLabel;
